<template>
	<div>
		<p v-if="!filtrar" style="margin-bottom: 4px" class="text-info">
			<div v-if="texto === 'solicitações' || texto === 'ordem'">
				<AlertInfo>
				{{ _traducao('global', 'aListaAbaixo') }} {{ _traducao('global', 'estaExibindo') }} {{ _traducao('global', 'asUltimas') }} 20 {{ texto == 'ordem' ? 'ordens' : texto}}.
				<!-- {{ _traducao('global', 'aListaAbaixo') }} {{ _traducao('global', 'estaExibindo') }} {{ _traducao('global', 'asUltimas') }} {{ texto }} {{ _traducao('global', 'dosUltimos') }} {{ ultimosDias }} {{ _traducao('global', 'dias') }}. -->
					<a
					href="#"
					@click.prevent="
						$refs.modalFiltro.modalShow(50)	
						setStartDates()
					"
					><i class="fa fa-fw fa-filter"></i>{{ _traducao('global', 'filtrar') }} {{ _traducao('global', 'maisDias') }}.</a>
				</AlertInfo>
			</div>
			<div v-else-if="texto === 'despachos'">
				<AlertInfo>
					{{ _traducao('global', 'aListaAbaixo') }} {{ _traducao('global', 'estaExibindo') }} {{ _traducao('global', 'osUltimos') }} 20 {{ 'registros' }}.
				<a
					href="#"
					@click.prevent="
						$refs.modalFiltro.modalShow(50)	
						setStartDates()
					"
					><i class="fa fa-fw fa-filter"></i>{{ _traducao('global', 'filtrar') }} {{ _traducao('global', 'porPeriodo') }}.</a
				>
			</AlertInfo>
			</div>
			<div v-else-if="texto === 'registro'">
				<AlertInfo>
					{{ _traducao('global', 'aListaAbaixo') }} {{ _traducao('global', 'estaExibindo') }} {{ _traducao('global', 'osUltimos') }} 20 {{ 'registros' }}.
					<a
						href="#"
						@click.prevent="
							$refs.modalFiltro.modalShow(50)	
							setStartDates()
						"
					>
						<i class="fa fa-fw fa-filter"/>
						{{ _traducao('global', 'filtrar') }} 
						{{ _traducao('global', 'porPeriodo') }}.
					</a>
				</AlertInfo>
			</div>

			<div v-else-if="texto == 'os'">
				<div class="box-secundary">
					<a
						href="#"
						@click.prevent="
							$refs.modalFiltro.modalShow(50)	
							setStartDates()
						"				
			
						><i class="fa fa-fw fa-filter"></i>{{ _traducao('global', 'filtrar') }} por data.</a
					>
				</div>
			</div>

			<div v-else>
			<AlertInfo>
				{{ _traducao('global', 'aListaAbaixo') }} {{ _traducao('global', 'estaExibindo') }} {{ _traducao('global', 'asUltimas') }} {{ texto }} {{ _traducao('global', 'dosUltimos') }} {{ ultimosDias }} {{ _traducao('global', 'dias') }}.
				<a
					href="#"
					@click.prevent="
						$refs.modalFiltro.modalShow(50)	
						setStartDates()
					"
					><i class="fa fa-fw fa-filter"></i>{{ _traducao('global', 'filtrar') }} {{ _traducao('global', 'maisDias') }}.</a
				>
			</AlertInfo>
			</div>
		</p>

		<div v-if="filtrar">
			<p style="margin-bottom: 4px" class="text-info">
				<i class="fa fa-fw fa-info-circle"></i> {{ _traducao('global', 'aListaAbaixo') }}
				{{ _traducao('global', 'estaExibindo') }} {{ msgPersonalizada == null ? texto : msgPersonalizada }} {{ _traducao('global', 'de2') }} {{ inicio }}
				{{ _traducao('global', 'ate') }} {{ fim }}.
				<a href="#" @click.prevent="$refs.modalFiltro.modalShow(50)"
					><i class="fa fa-fw fa-refresh"></i>{{ _traducao('global', 'alterar') }}.</a
				>
			</p>
			<p style="margin-bottom: 0px; margin-top: 8px">
				<a href="#" @click.prevent="clickRemoveFiltro()"
					><i class="fa fa-fw fa-times"></i>{{ _traducao('global', 'limparFiltro') }}.</a
				>
			</p>
		</div>

		<modal ref="modalFiltro">
			<h4>
				<i class="fa fa-fw fa-filter"></i>
				{{ _traducao('global', 'filtrar').toUpperCase() }}
				<button type="button" class="close" @click="$refs.modalFiltro.modalHide()">
					<span aria-hidden="true">&times;</span>
				</button>
			</h4>

			<hr style="margin-top: 20px; margin-bottom: 10px" />

			<div class="row form-group">
				<div class="col-xs-12 col-md-6">
					<!-- <label>Início:</label> -->
					<flDateTime
						@v-model="(val) => (inicio = val)"
						:value="inicio"
						name="dtOrdemInicio"
						:lang="_getLangDp"
						:inline="true"
						:format="_formatDate"
					/>
				</div>
				<div class="col-xs-12 col-md-6">
					<!-- <label>Fim:</label> -->
					<flDateTime
						@v-model="(val) => (fim = val)"
						:value="fim"
						name="dtOrdemInicio"
						:lang="_getLangDp"
						:inline="true"
						:minDate="inicio"
						:format="_formatDate"
					/>
				</div>
			</div>

			<div class="row form-group">
				<div class="col-xs-6 col-md-6">
					<h3 class="text-center">
						{{ _traducao('global', 'inicio') }} <br />
						<small>{{ inicio }}</small>
					</h3>
				</div>
				<div class="col-xs-6 col-md-6">
					<h3 class="text-center">
						{{ _traducao('global', 'fim') }} <br />
						<small>{{ fim }}</small>
					</h3>
				</div>
			</div>

			<hr />

			<div class="row">
				<div class="col-xs-12 col-md-8">
					<p class="text-info">
						<i class="fa fa-fw fa-info-circle"></i> {{ _traducao('global', 'quandoPesquisarPorLongosPeriodos') }},
						{{ _traducao('global', 'oResultadoPodeDemorarUmPouco') }}.
					</p>
				</div>
				<div class="col-md-4 col-xs-12">
					<button :disabled="inicio == '' || fim == ''" @click="clickFiltrar()" class="btn btn-success pull-right">
						<i class="fa fa-fw fa-filter"></i> {{ _traducao('global', 'filtrar') }}
					</button>
				</div>
			</div>
		</modal>
	</div>
</template>

<style scoped>
.h4 {
	border: none;
}

.fl-cabecalho .row {
	border: none;
}

.box-secundary{
	padding: 10px; 
	display: flex; 
	margin-bottom: 12px; 
	margin-top: 3px;
	border: 1px solid #bce8f1; 
	background-color: #d9edf7;
}
</style>

<script>
export default {
	props: {
		ultimosDias: {
			type: Number,
			default: 60,
			required: false
		},

		texto: {
			type: String,
			required: true
		},

		msgPersonalizada: {
			type: String,
			default: null,
			required: false
		}
	},

	data() {
		return {
			inicio: '',
			fim: '',
			filtrar: false
		}
	},

	mounted() {},

	methods: {
		setStartDates() {
			if (this.inicio == '') {
				this.inicio = new moment().subtract(60, 'days').format($sessao.getDateFormat())
				this.fim = new moment().format($sessao.getDateFormat())
			}
		},

		clickFiltrar() {
			this.filtrar = true
			this.$emit('filtrar', this.inicio, this.fim)
			this.$refs.modalFiltro.modalHide()
		},

		clickRemoveFiltro() {
			this.filtrar = false
			this.inicio = ''
			this.fim = ''
			this.$emit('limpar-filtros')
		}
	}
}
</script>